import type { ReactNode } from "react";

import "./EmptyState.css";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="bmd-empty">
      <div className="bmd-empty-mark" aria-hidden="true" />
      <h3 className="bmd-empty-title">{title}</h3>
      {description && <p className="bmd-empty-desc">{description}</p>}
      {action && <div className="bmd-empty-action">{action}</div>}
    </div>
  );
}
